import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import mainPath from '../utils/path';
import MagicSliderDots from 'react-magic-slider-dots';
import 'react-magic-slider-dots/dist/magic-dots.css';

const useStyles = makeStyles((theme) => ({    
    backG:{
        boxSizing: 'border-box',
        position:'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 999,
        overflow: 'auto',
        outline: 0,  
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
    mainB:{
        margin:'0 auto',
        marginTop: '10vh',
        marginBottom: '0 auto',
        zIndex: 1000,
        maxWidth: 500,
        backgroundColor:'white',
        borderRadius: '10px',
        [theme.breakpoints.down(1025)]: {
            maxWidth: 400,
        },
        [theme.breakpoints.down(400)]: {
            maxWidth: '90%',
        }
    },
    mainBottom: {
        width: '100%',
        height: 50,
        backgroundColor: 'black',
        display: 'flex'
    },
    closeBox: {
        color: 'white',
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    },

}))

const Popup = ({popUps, setPopUps, dayClose}) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const settings1 = {
        dots : true,
        autoplay : true,
        arrows: false,
        autoplaySpeed : 3000,
        slidesToShow : 1,
        slidesToScroll : 1, 
        appendDots: (dots) => (
            <div
                style={{
                    transform: 'translateY(-50px)'
                }}
            >
                <MagicSliderDots 
                    dots={dots} 
                    numDotsToShow={5} 
                    dotWidth={40}
                />
            </div>

        ) ,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            },
        ]
    };



  return (
    <div className={classes.backG}>
        <div className={classes.mainB}>
            <Slider {...settings1} className={classes.slide}>
                {popUps.map((itm, idx) => (
                    <img 
                        key={idx}
                        src={`${mainPath}/media/data/popup/${itm.img1}`}
                    />)
                )}
                
            </Slider>
            <div
                className={classes.mainBottom}
            >
                <div
                    className={classes.closeBox}
                    onClick={() => dayClose()}
                >
                    오늘 하루 닫기
                </div>
                <div
                    className={classes.closeBox}
                    onClick={() => setPopUps([])}
                >
                    닫기
                </div>
            </div>
        </div>
    </div>
  )
}

export default Popup
